// Menu completo trilingue (IT / DE / EN). v: 'veg' | 'vegan' — spicy: 1-3 — prices: [{ value, label? }]
const tri = (it, de, en) => ({ it, de, en });
const same = (s) => ({ it: s, de: s, en: s });
const price = (value, label) => ({ value, label });

export const menuUi = {
  priceNote: tri(
    "Prezzi in CHF • IVA inclusa",
    "Preise in CHF • inkl. MwSt.",
    "Prices in CHF • VAT included"
  ),
  meatNote: tri(
    "Se non specificato altro, carne svizzera di 1ª qualità. Provenienza della carne e dei prodotti di carne con *, e del pesce: vedi lavagna esposta al bar. Salvo modifiche.",
    "Sofern nicht anders angegeben, Schweizer Fleisch 1. Qualität. Herkunft von Fleisch und Fleischprodukten mit * sowie des Fisches: siehe Tafel an der Bar. Änderungen vorbehalten.",
    "Unless otherwise stated, premium-quality Swiss meat. Origin of meat and meat products marked * and of fish: see the blackboard at the bar. Subject to change."
  ),
  dishes: tri("piatti", "Gerichte", "dishes"),
  dish: tri("piatto", "Gericht", "dish"),
  seasonal: tri("Stagionale", "Saisonal", "Seasonal"),
  veg: tri("piatti vegetariani", "vegetarische Gerichte", "vegetarian dishes"),
  vegan: tri("piatti vegani", "vegane Gerichte", "vegan dishes"),
  spicy1: tri("Leggermente piccante", "Leicht scharf", "Mildly spicy"),
  spicy2: tri("Piccante", "Scharf", "Spicy"),
  spicy3: tri("Molto piccante", "Sehr scharf", "Very spicy"),
  pickCategory: tri("Scegli una sezione", "Wähle eine Rubrik", "Choose a section"),
  inclSide: tri("Contorno a scelta", "Beilage nach Wahl", "Side dish of your choice"),
  inclSideDesc: tri(
    "patatine fritte, riso o verdure",
    "Pommes frites, Reis oder Gemüse",
    "french fries, rice or vegetables"
  ),
  pernote: tri("p.p.", "p.P.", "p.p."),
  by24h: tri(
    "Solo su riservazione 24 ore prima (min. 2 pers.)",
    "Nur auf Vorbestellung 24 Stunden im Voraus (mind. 2 Pers.)",
    "By reservation only, 24 hours in advance (min. 2 people)"
  ),
  wildMenuTitle: tri("Menù di Selvaggina", "Wildmenü", "Game Menu"),
  wildOrigin: tri("Provenienza della carne", "Fleischherkunft", "Meat origin"),
  wildOriginText: tri(
    "Cervo: NZ • Capriolo: AT, DE • Cinghiale: ES",
    "Hirsch: NZ • Reh: AT, DE • Wildschwein: ES",
    "Venison: NZ • Roe deer: AT, DE • Wild boar: ES"
  ),
};

export const wildMenu = {
  price: "64.00",
  courses: [
    {
      label: tri("Antipasto autunnale", "Herbstliche Vorspeise", "Autumn starter"),
      text: tri(
        "Crema di zucca, carne secca di cervo, mousse al fegato d'anatra e salamino di cinghiale",
        "Kürbiscreme, Hirsch-Trockenfleisch, Entenlebermousse und Wildschweinsalami",
        "Pumpkin cream, dried venison, duck liver mousse and wild boar salami"
      ),
    },
    {
      label: tri("Secondo", "Hauptgang", "Main course"),
      text: tri(
        "Scaloppine di capriolo con salsa ai funghi e contorno autunnale",
        "Rehschnitzel mit Pilzsauce und herbstlicher Beilage",
        "Roe deer escalope with mushroom sauce and autumn side dishes"
      ),
    },
    {
      label: tri("Dessert", "Sorbet", "Dessert"),
      text: tri("Sorbetto", "Sorbet", "Sorbet"),
    },
  ],
};

const autumnSides = (de, en) => tri(
  "salsa ai funghi, con spätzli, cavoli rossi, castagne e mela ai mirtilli rossi",
  `${de} mit Pilzsauce, dazu Spätzli, Rotkohl, Kastanien und Apfel mit Preiselbeeren`,
  `${en} with mushroom sauce, served with spätzli, red cabbage, chestnuts and apple with cranberries`
);

export const menuCategories = [
  {
    key: "condividere",
    icon: "Utensils",
    title: tri("Da condividere & Antipasti", "Zum Teilen & Vorspeisen", "To Share & Starters"),
    alt: tri("Zum gemeinsamen Genuss", "Da condividere / Antipasti", "Da condividere / Antipasti"),
    groups: [
      {
        title: tri("Da condividere", "Zum gemeinsamen Genuss", "To share"),
        items: [
          {
            name: tri("Bruschetta al pomodoro", "Bruschetta mit Tomaten", "Tomato bruschetta"),
            desc: tri("", "", ""),
            v: "vegan",
            prices: [price("12.00")],
          },
          {
            name: tri("Focaccia al rosmarino", "Rosmarin-Focaccia", "Rosemary focaccia"),
            desc: tri(
              "sale marino, olio extra vergine di oliva, accompagnata con prosciutto crudo*",
              "Meersalz, natives Olivenöl extra, begleitet von Rohschinken*",
              "sea salt, extra virgin olive oil, served with cured ham*"
            ),
            prices: [price("25.00")],
          },
        ],
      },
      {
        title: tri("Antipasti", "Vorspeisen", "Starters"),
        items: [
          {
            name: tri("Bresaola carpacciata", "Bresaola-Carpaccio", "Bresaola carpaccio"),
            desc: tri(
              "con rucola e grana",
              "mit Rucola und Parmesan",
              "with rocket and grana cheese"
            ),
            prices: [price("25.00")],
          },
          {
            name: tri("Tartare di manzo", "Rindertartar", "Beef tartare"),
            desc: tri(
              "servito con pane toast e burro",
              "serviert mit Toast und Butter",
              "served with toast and butter"
            ),
            prices: [price("27.00", "100 g")],
          },
          {
            name: tri("Cozze alla busara", "Miesmuscheln alla busara", "Mussels busara-style"),
            desc: tri(
              "con crostini di pane",
              "mit Croutons",
              "with bread croutons"
            ),
            spicy: 1,
            prices: [price("25.00")],
          },
          {
            name: tri("Insalata di frutti di mare", "Meeresfrüchtesalat", "Seafood salad"),
            desc: tri(
              "olio al prezzemolo e limone",
              "mit Petersilie und Zitronenöl",
              "with parsley and lemon oil"
            ),
            prices: [
              price("22.00", "½"),
              price("32.00", "1/1"),
            ],
          },
        ],
      },
    ],
  },
  {
    key: "insalate",
    icon: "Salad",
    title: tri("Insalate", "Salate", "Salads"),
    alt: tri("Insalate / Salate", "Insalate / Salate", "Insalate / Salate"),
    groups: [
      {
        items: [
          { name: tri("Insalate in foglie", "Blattsalat", "Leaf salad"), desc: tri("", "", ""), prices: [price("8.00")] },
          { name: tri("Insalata mista", "Gemischter Salat", "Mixed salad"), desc: tri("", "", ""), prices: [price("10.00")] },
          { name: tri("Insalata di pomodoro e cipolle", "Tomaten-Zwiebel-Salat", "Tomato and onion salad"), desc: tri("", "", ""), prices: [price("10.00")] },
          { name: tri("Insalata mista grande", "Großer gemischter Salat", "Large mixed salad"), desc: tri("", "", ""), prices: [price("17.00")] },
          {
            name: tri("Insalata \"Mezzaluna\"", "Salat \"Mezzaluna\"", "\"Mezzaluna\" salad"),
            desc: tri("con petto di pollo", "mit Hähnchenbrust", "with chicken breast"),
            prices: [price("27.00")],
          },
        ],
      },
    ],
  },
  {
    key: "pasta",
    icon: "Wheat",
    title: tri("Pasta", "Nudeln", "Pasta"),
    alt: tri("Nudeln", "Pasta", "Pasta"),
    groups: [
      {
        items: [
          {
            name: tri("Gnocchetti sardi", "Sardische Gnocchi", "Sardinian gnocchetti"),
            desc: tri(
              "con zucchine, pomodorini e basilico",
              "mit Zucchini, Kirschtomaten und Basilikum",
              "with zucchini, cherry tomatoes and basil"
            ),
            v: "vegan",
            prices: [price("24.00")],
          },
          {
            name: tri("Gnocchetti sardi", "Sardische Gnocchi", "Sardinian gnocchetti"),
            desc: tri(
              "con gamberoni, zucchine, burrata e pomodorini",
              "mit Riesengarnelen, Zucchini, Burrata und Kirschtomaten",
              "with king prawns, zucchini, burrata and cherry tomatoes"
            ),
            prices: [price("28.00")],
          },
          {
            name: tri("Spaghetti alla carbonara", "Spaghetti Carbonara", "Spaghetti carbonara"),
            desc: tri(
              "uovo, guanciale*, parmigiano e pepe",
              "Ei, Guanciale*, Parmesan und Pfeffer",
              "egg, guanciale*, parmesan and pepper"
            ),
            prices: [price("25.00")],
          },
          {
            name: tri("Spaghetti alle vongole", "Spaghetti mit Venusmuscheln", "Spaghetti with clams"),
            desc: tri("", "", ""),
            spicy: 1,
            prices: [price("25.00")],
          },
          {
            name: tri("Spaghetti allo scoglio", "Spaghetti mit Meeresfrüchten", "Spaghetti with seafood"),
            desc: tri("", "", ""),
            spicy: 1,
            prices: [price("28.00")],
          },
        ],
      },
    ],
  },
  {
    key: "pizza",
    icon: "Pizza",
    title: tri("Pizza", "Pizza", "Pizza"),
    alt: tri("Forno a legna / Holzbackofen", "Forno a legna", "Wood-fired oven"),
    extras: {
      title: tri("Extra", "Extra", "Extras"),
      rows: [
        { name: tri("Pizza piccola – riduzione", "Kleine Pizza – Ermässigung", "Small pizza – discount"), value: "−2.00" },
        { name: tri("Patatine fritte", "Pommes frites", "French fries"), value: "5.00", group: tri("Supplementi extra", "Zusätze", "Extra toppings & sides") },
        { name: tri("Pizza tagliata in due piatti", "Pizza auf zwei Teller serviert", "Pizza cut and served on two plates"), value: "3.00" },
        { name: tri("Prosciutto cotto, rucola, mascarpone", "Kochschinken, Rucola, Mascarpone", "Cooked ham, rocket, mascarpone"), value: "3.00" },
        { name: tri("Frutti di mare e porcini", "Meeresfrüchte und Steinpilze", "Seafood and porcini mushrooms"), value: "5.00" },
        { name: tri("Prosciutto crudo", "Rohschinken", "Cured ham"), value: "5.00" },
      ],
    },
    groups: [
      {
        items: [
          { name: same("Margherita"), desc: tri("pomodoro e mozzarella", "Tomaten und Mozzarella", "tomato and mozzarella"), v: "veg", prices: [price("15.00")] },
          { name: same("Bufalina"), desc: tri("pomodoro, mozzarella, mozzarella di bufala e basilico", "Tomaten, Mozzarella, Büffelmozzarella und Basilikum", "tomato, mozzarella, buffalo mozzarella and basil"), v: "veg", prices: [price("19.00")] },
          { name: tri("Prosciutto", "Schinken", "Ham"), desc: tri("pomodoro, mozzarella e prosciutto", "Tomaten, Mozzarella und Schinken", "tomato, mozzarella and ham"), prices: [price("19.00")] },
          { name: tri("Prosciutto e funghi", "Schinken und Champignons", "Ham and mushrooms"), desc: tri("pomodoro, mozzarella, prosciutto e funghi", "Tomaten, Mozzarella, Schinken und Champignons", "tomato, mozzarella, ham and mushrooms"), prices: [price("19.50")] },
          { name: tri("Funghi", "Champignons", "Mushrooms"), desc: tri("pomodoro, mozzarella e funghi", "Tomaten, Mozzarella und Champignons", "tomato, mozzarella and mushrooms"), v: "veg", prices: [price("19.00")] },
          { name: same("Padrino"), desc: tri("pomodoro, mozzarella, prosciutto e gorgonzola", "Tomaten, Mozzarella, Schinken und Gorgonzola", "tomato, mozzarella, ham and gorgonzola"), prices: [price("20.00")] },
          { name: same("Quattro stagioni"), desc: tri("pomodoro, mozzarella, prosciutto, funghi, peperoni, carciofi e olive", "Tomaten, Mozzarella, Schinken, Champignons, Paprika, Artischocken und Oliven", "tomato, mozzarella, ham, mushrooms, peppers, artichokes and olives"), prices: [price("21.00")] },
          { name: same("Quattro formaggi"), desc: tri("pomodoro, mozzarella, mascarpone, gorgonzola e grana", "Tomaten, Mozzarella, Mascarpone, Gorgonzola und Parmesan", "tomato, mozzarella, mascarpone, gorgonzola and grana cheese"), v: "veg", prices: [price("20.50")] },
          { name: tri("Tonno e cipolla", "Thunfisch und Zwiebeln", "Tuna and onion"), desc: tri("pomodoro, mozzarella, tonno e cipolla", "Tomaten, Mozzarella, Thunfisch und Zwiebeln", "tomato, mozzarella, tuna and onion"), prices: [price("19.50")] },
          { name: same("Pizza Sandwich"), desc: tri("rucola, pomodoro fresco, prosciutto crudo e stracciatella di burrata", "Rucola, frische Tomaten, Rohschinken und Burrata-Stracciatella", "rocket, fresh tomato, cured ham and burrata stracciatella"), prices: [price("23.00")] },
          { name: tri("Frutti di mare", "Meeresfrüchte", "Seafood"), desc: tri("pomodoro, mozzarella e frutti di mare", "Tomaten, Mozzarella und Meeresfrüchte", "tomato, mozzarella and seafood"), prices: [price("23.50")] },
          { name: same("Carpaccio"), desc: tri("pomodoro, mozzarella, carpaccio di manzo*, rucola e grana", "Tomaten, Mozzarella, Rindercarpaccio*, Rucola und Parmesan", "tomato, mozzarella, beef carpaccio*, rocket and grana cheese"), prices: [price("23.00")] },
          { name: same("Calabrese"), desc: tri("pomodoro, mozzarella, salame piccante*, acciughe, peperoni e olive", "Tomaten, Mozzarella, scharfe Salami*, Sardellen, Paprika und Oliven", "tomato, mozzarella, spicy salami*, anchovies, peppers and olives"), spicy: 1, prices: [price("20.00")] },
          { name: same("Fitness"), desc: tri("mozzarella, bresaola*, rucola, pomodoro cherry e grana", "Mozzarella, Bresaola*, Rucola, Kirschtomaten und Parmesan", "mozzarella, bresaola*, rocket, cherry tomatoes and grana cheese"), prices: [price("23.00")] },
          { name: same("Rustica"), desc: tri("pomodoro, mozzarella, salame piccante*, pancetta, peperoni, cipolle e olive", "Tomaten, Mozzarella, scharfe Salami*, Speck, Paprika, Zwiebeln und Oliven", "tomato, mozzarella, spicy salami*, pancetta, peppers, onions and olives"), spicy: 1, prices: [price("21.00")] },
          { name: same("Valtellinese"), desc: tri("pomodoro, mozzarella e bresaola", "Tomaten, Mozzarella und Bresaola", "tomato, mozzarella and bresaola"), prices: [price("22.00")] },
          { name: tri("Vegetariana", "Vegetarische", "Vegetarian"), desc: tri("pomodoro, mozzarella, zucchine e melanzane grigliate", "Tomaten, Mozzarella, gegrillte Zucchini und Auberginen", "tomato, mozzarella, grilled zucchini and aubergine"), v: "veg", prices: [price("19.00")] },
          { name: same("Fiorentina"), desc: tri("pomodoro, mozzarella, spinaci, mascarpone e uovo", "Tomaten, Mozzarella, Spinat, Mascarpone und Ei", "tomato, mozzarella, spinach, mascarpone and egg"), v: "veg", prices: [price("19.00")] },
          { name: tri("Burrata e crudo", "Burrata und Rohschinken", "Burrata and cured ham"), desc: tri("pomodoro, mozzarella, burrata e crudo", "Tomaten, Mozzarella, Burrata und Rohschinken", "tomato, mozzarella, burrata and cured ham"), prices: [price("24.00")] },
          { name: same("Napoli"), desc: tri("pomodoro, mozzarella, acciughe e capperi", "Tomaten, Mozzarella, Sardellen und Kapern", "tomato, mozzarella, anchovies and capers"), prices: [price("19.00")] },
          { name: same("Pugliese"), desc: tri("pomodoro, mozzarella e cipolla", "Tomaten, Mozzarella und Zwiebeln", "tomato, mozzarella and onion"), v: "veg", prices: [price("17.00")] },
          { name: same("Mezzaluna"), desc: tri("pomodoro, mozzarella, prosciutto, porcini, spinaci e uovo", "Tomaten, Mozzarella, Schinken, Steinpilze, Spinat und Ei", "tomato, mozzarella, ham, porcini mushrooms, spinach and egg"), prices: [price("22.50")] },
          { name: same("Contadina"), desc: tri("pomodoro, mozzarella, pancetta affumicata, uovo e cipolla", "Tomaten, Mozzarella, geräucherter Speck, Ei und Zwiebeln", "tomato, mozzarella, smoked pancetta, egg and onion"), prices: [price("19.50")] },
          { name: same("Diavola"), desc: tri("pomodoro, mozzarella e salame piccante*", "Tomaten, Mozzarella und scharfe Salami*", "tomato, mozzarella and spicy salami*"), spicy: 1, prices: [price("19.00")] },
          { name: same("Italia"), desc: tri("pomodoro, mozzarella, mascarpone e rucola", "Tomaten, Mozzarella, Mascarpone und Rucola", "tomato, mozzarella, mascarpone and rocket"), v: "veg", prices: [price("19.00")] },
          { name: same("Riazzino"), desc: tri("pomodoro, mozzarella, carciofi, mascarpone e prosciutto crudo*", "Tomaten, Mozzarella, Artischocken, Mascarpone und Rohschinken*", "tomato, mozzarella, artichokes, mascarpone and cured ham*"), prices: [price("23.00")] },
          { name: same("Capricciosa"), desc: tri("pomodoro, mozzarella, prosciutto, funghi, salame piccante*, carciofi, peperoni, acciughe e olive", "Tomaten, Mozzarella, Schinken, Champignons, scharfe Salami*, Artischocken, Paprika, Sardellen und Oliven", "tomato, mozzarella, ham, mushrooms, spicy salami*, artichokes, peppers, anchovies and olives"), spicy: 1, prices: [price("21.50")] },
        ],
      },
    ],
  },
  {
    key: "carne",
    icon: "Beef",
    title: tri("Secondi di carne", "Fleischgerichte", "Meat Mains"),
    alt: tri("Fleisch Gerichte", "Secondi di carne", "Secondi di carne"),
    sideIncluded: true,
    groups: [
      {
        items: [
          {
            name: tri("Tartare di manzo", "Rindertartar", "Beef tartare"),
            desc: tri("servito con pane tostato e burro", "Tatar vom Rind mit Toast und Butter", "served with toasted bread and butter"),
            prices: [price("39.00", "250 g")],
          },
          {
            name: tri("Manzo Thai", "Thai-Rind", "Thai-style beef"),
            desc: tri(
              "bocconcini di manzo con verdure, salsa di soia leggermente piccante, riso",
              "Rindfleisch mit Gemüse, leicht pikanter Sojasauce und Reis",
              "beef morsels with vegetables, mildly spicy soy sauce, rice"
            ),
            spicy: 1,
            prices: [price("38.00", "150 g")],
          },
          {
            name: tri("Paillard di vitello", "Kalbfleisch Paillard", "Veal paillard"),
            desc: tri("", "", ""),
            prices: [price("38.00", "200 g")],
          },
          {
            name: tri("Tagliata di manzo", "Rindfleisch in Scheiben", "Sliced beef (Tagliata)"),
            desc: tri("", "", ""),
            prices: [price("39.00", "250 g")],
          },
          {
            name: tri("Cordon bleu di vitello", "Kalbs-Cordon bleu", "Veal cordon bleu"),
            desc: tri("", "", ""),
            prices: [price("29.00", "200 g"), price("39.00", "400 g")],
          },
        ],
      },
    ],
  },
  {
    key: "pesce",
    icon: "Fish",
    title: tri("Secondi di pesce", "Fischgerichte", "Fish Mains"),
    alt: tri("Fisch Gerichte", "Secondi di pesce", "Secondi di pesce"),
    sideIncluded: true,
    groups: [
      {
        items: [
          {
            name: tri("Code di gamberoni", "Garnelenschwänze", "King prawn tails"),
            desc: tri(
              "con tartare di avocado guacamole",
              "mit Avocado-Guacamole-Tatar",
              "with avocado guacamole tartare"
            ),
            prices: [price("39.00")],
          },
          {
            name: tri("Code di gamberoni spadellate", "Gebratene Riesengarnelenschwänze", "Pan-fried king prawn tails"),
            desc: tri("", "", ""),
            prices: [price("39.00")],
          },
          {
            name: tri("Filetti di orata alla mediterranea", "Doradenfilets mediterran", "Mediterranean sea bream fillets"),
            desc: tri(
              "con olive, pomodorini, capperi, olio extravergine di oliva e origano",
              "mit Oliven, Kirschtomaten, Kapern, nativem Olivenöl extra und Oregano",
              "with olives, cherry tomatoes, capers, extra virgin olive oil and oregano"
            ),
            prices: [price("36.00")],
          },
        ],
      },
    ],
  },
  {
    key: "selvaggina",
    icon: "TreePine",
    seasonal: true,
    title: tri("Rassegna della Selvaggina", "Wildspezialitäten", "Game Specialties"),
    alt: tri("Wildspezialitäten", "Rassegna della Selvaggina", "Rassegna della Selvaggina"),
    groups: [
      {
        items: [
          {
            name: tri("Antipasto autunnale", "Herbstliche Vorspeise", "Autumn starter"),
            desc: tri(
              "crema di zucca e croccante agli amaretti, salametto di cinghiale, mousse al fegato d'anatra e carne secca di cervo",
              "Kürbiscreme mit Amaretti-Krokant, Wildschweinsalami, Entenlebermousse und Hirsch-Trockenfleisch",
              "pumpkin cream with amaretti crunch, wild boar salami, duck liver mousse and dried venison"
            ),
            prices: [price("32.00"), price("26.00", "½")],
          },
          {
            name: tri("Battuta al coltello di filetto di cervo", "Handgeschnittenes Hirschfilet-Tatar", "Hand-cut venison fillet tartare"),
            desc: tri("", "", ""),
            prices: [price("37.00")],
          },
          {
            name: tri("Pappardelle", "Pappardelle", "Pappardelle"),
            desc: tri("con ragù di cinghiale", "mit Wildschweinragout", "with wild boar ragù"),
            prices: [price("26.00")],
          },
          {
            name: tri("Gnocchetti di castagne", "Kastaniengnocchetti", "Chestnut gnocchetti"),
            desc: tri(
              "con funghi alla crema, zucca e mirtilli",
              "mit Pilzen an Rahmsauce, Kürbis und Heidelbeeren",
              "with mushrooms in cream sauce, pumpkin and blueberries"
            ),
            v: "veg",
            prices: [price("27.00")],
          },
          {
            name: tri("Medaglioni di filetto di cervo", "Hirschfilet-Medaillons", "Venison fillet medallions"),
            desc: autumnSides("Hirschfilet-Medaillons", "Venison fillet medallions"),
            prices: [price("42.00")],
          },
          {
            name: tri("Filetto di cinghiale", "Wildschweinfilet", "Wild boar fillet"),
            desc: autumnSides("Wildschweinfilet", "Wild boar fillet"),
            prices: [price("38.00")],
          },
          {
            name: tri("Scaloppine di capriolo", "Rehschnitzel", "Roe deer escalopes"),
            desc: autumnSides("Rehschnitzel", "Roe deer escalopes"),
            prices: [price("39.00")],
          },
          {
            name: tri("Sella di capriolo «Baden-Baden»", "Rehrücken «Baden-Baden»", "Saddle of roe deer «Baden-Baden»"),
            desc: tri(
              "con i suoi contorni, servita in due portate",
              "Rehrücken «Baden-Baden» mit Beilage, in zwei Gängen serviert",
              "Roe deer saddle «Baden-Baden» with its side dishes, served in two courses"
            ),
            note: "by24h",
            prices: [price("64.00", "p.p.")],
          },
        ],
      },
    ],
  },
];
